export default __webpack_public_path__ + "static/media/animat-lightbulb-color.0961c480.gif";